import Vue from 'vue'
import EventBus from './../event-bus'
import GuideBase from './tools/guide-base'

let STATES

let MainNavStageGuide = new Vue({
  extends: GuideBase,
  beforeCreate () {
    STATES = this.STATES
  },
  methods: {
    step1: function () {
      if (this._data.state >= STATES.STEP_1) return
      this._data.state = STATES.STEP_1
      EventBus.dispatchEvent('HOWTO_RUNNING', true)
    },
    complete: function () {
      if (this._data.state >= STATES.STEP_2) return
      this._data.state = STATES.STEP_2
      EventBus.dispatchEvent('HOWTO_RUNNING', false)
    }
  }
})

export default MainNavStageGuide
